import { render, staticRenderFns } from "./ImageOnHoverChangeColor.vue?vue&type=template&id=1193668b&scoped=true"
import script from "./ImageOnHoverChangeColor.vue?vue&type=script&lang=ts"
export * from "./ImageOnHoverChangeColor.vue?vue&type=script&lang=ts"
import style0 from "./ImageOnHoverChangeColor.vue?vue&type=style&index=0&id=1193668b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193668b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VHover,VImg})
